import React from 'react';
import './PrivacyPolicyPage.css';

const permissions = ['Storage', 'Security'];

const PrivacyPolicyPage = () => (
  <main className="enhanced-page privacy-policy-page">
    <section
      className="enhanced-hero privacy-hero"
      style={{ backgroundImage: 'url(/dts-assets/ai/company-profile-hero.png)' }}
    >
      <div className="container enhanced-hero-grid">
        <div className="enhanced-copy reveal-left">
          <span className="section-label eyebrow-dark">Privacy Policy</span>

          <h1>
            Privacy Policy – <em>Dynamic Tracking Solutions Pvt. Ltd.</em>
          </h1>

          <p>
            This privacy policy sets out how Dynamic Tracking Solutions Pvt. Ltd.
            Mobile Application uses and protects any information that you give
            when you use this app.
          </p>

          <div className="hero-actions">
            <a href="/contact-us" className="btn btn-primary">
              Contact Us
            </a>

            <a href="/" className="btn btn-outline">
              Back to Home
            </a>
          </div>

          <div className="hero-metrics">
            <span>
              <strong>2019</strong>
              Since
            </span>
            <span>
              <strong>Secure</strong>
              Application
            </span>
            <span>
              <strong>Privacy</strong>
              Protected
            </span>
          </div>
        </div>

        <div className="hero-visual-wrap reveal">
          <div className="floating-orbit" />
          <div className="float-chip one">
            <b />
            Secure App
          </div>
          <div className="float-chip two">
            <b />
            Data Protection
          </div>

          <div className="hero-visual">
            <img src="/dts-assets/ai/company-profile-hero.png" alt="Privacy Policy" />
          </div>
        </div>
      </div>
    </section>

    <section className="enhanced-section alt">
      <div className="container">
        <div className="privacy-wrapper reveal">
          <div className="privacy-intro-card">
            <span className="section-label">Effective From</span>
            <h2>April 17, 2026</h2>
            <p>
              Being a reputed company since 2019, Dynamic Tracking Solutions Pvt.
              Ltd. provides quality service to you.
            </p>
          </div>

          <div className="privacy-content-card">
            <h2>Privacy Policy – Dynamic Tracking Solutions Pvt. Ltd.</h2>

            <p>
              This privacy policy sets out how Dynamic Tracking Solutions Pvt. Ltd.
              Mobile Application uses and protects any information that you give
              when you use this app. Being a reputed company since 2019, Dynamic
              Tracking Solutions Pvt. Ltd. provides quality service to you.
            </p>

            <p>
              The Dynamic Tracking Solutions Mobile Application is committed to
              ensuring that your privacy is protected. We may ask you to provide
              certain permissions to enhance your own user experience, which do not
              include any of your private data and are only used in accordance with
              this privacy statement.
            </p>

            <p>
              Dynamic Tracking Solutions Pvt. Ltd. may change this policy from time
              to time by updating this page. You should check this page periodically
              to ensure you agree with any changes. This policy is effective from
              April 17, 2026.
            </p>

            <div className="privacy-block">
              <h3>What Permissions Are Required</h3>
              <p>We may ask for the following permissions:</p>

              <div className="permission-grid">
                {permissions.map((item) => (
                  <span key={item}>✓ {item}</span>
                ))}
              </div>
            </div>

            <div className="privacy-block">
              <h3>Security</h3>

              <p>
                We are committed to ensuring that your information is secure. In
                order to prevent unauthorized access or disclosure, we have put in
                place suitable physical, electronic, and managerial procedures to
                safeguard and secure the information we collect online.
              </p>

              <p>
                Placed cookies contain no personal information or any kind of your
                vehicle’s personal/tracking data — only the application’s basic
                options and settings are stored with secured encryption methodology.
              </p>
            </div>

            <div className="privacy-block">
              <h3>Data Collection</h3>

              <p>
                The Dynamic Tracking Solutions Mobile Application does not require
                or collect any of your personal data to operate. Images uploaded by
                users will not be shared with any other user of the application who
                is not entitled to view your shared images. There is no other means
                in the application to collect any image without user operation.
              </p>

              <p>
                No other device data is required or collected by Dynamic Tracking
                Solutions Mobile Application for any kind of operational purpose.
                All the information on the application that you see or use comes
                from our own database, which you provided to our company Dynamic
                Tracking Solutions Pvt. Ltd. at the time you joined us and started
                using our services.
              </p>

              <p>
                If you believe that any information, we are holding about you is
                incorrect or incomplete, please write to or email us at:
              </p>

              <a href="mailto:info@Dynamictracking.com" className="privacy-email">
                info@Dynamictracking.com
              </a>

              <p>
                as soon as possible. We will promptly correct any information if
                found incorrect.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default PrivacyPolicyPage;